import type { RootState } from '@core/Store'

export const selectIsRadioPlaying = (state: RootState): boolean => state.navigation.isRadioPlaying

export const selectIsRadioBusy = (state: RootState): boolean => state.navigation.isRadioBusy
